import React from 'react';
import {Link} from 'react-router-dom'
//import Auxiliar from '../assets/auxiliar.png';
//import Apoiar from '../assets/apoiar.png';
//import Contribuir from '../assets/contribuir.png';


const dashboard = (props) => {
    //console.log("logs Numbers ----->> " + props.logsNumber);
    //console.log("Register Date ----->> " + props.registerDate);
    //console.log("Register Date ----->> " + alert(JSON.stringify(props.registerDate)));

    return (

        <div className="container mt-6 col-12">
            <h3 className="text-center text-secondary mb-5">Painel de Administração</h3>
            <div className="row">
                <div className="col-xl-6 col-lg-6 mb-3">
                    <div className="card text-white bg-primary o-hidden h-100">
                        <div className="card-body d-flex justify-content-between align-items-center">
                            <div className="card-body-icon">
                                <i className="fas fa-users"></i>
                            </div>
                            <div className="mr-5">{props.registeredUsersNumber} utilizadores registados</div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 mb-3">
                    <div className="card text-white bg-secondary o-hidden h-100">
                        <div className="card-body d-flex justify-content-between align-items-center">
                            <div className="card-body-icon">
                                <i className="fas fa-calendar-alt"></i>
                            </div>
                            <div className="mr-5">O último registo foi efetuado a {props.registerDate}</div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 mb-3">
                    <div className="card text-white bg-secondary o-hidden h-100">
                        <div className="card-body d-flex justify-content-between align-items-center">
                            <div className="card-body-icon">
                                <i className="fas fa-clipboard-check"></i>
                            </div>
                            <div className="mr-5">{props.registeredFormsNumber} questionários associados</div>
                        </div>
                    </div>
                </div>
                 <div className="col-xl-6 col-lg-6 mb-3"><Link to="/login_logs">
                    <div className="card text-white bg-primary o-hidden h-100">
                        <div className="card-body d-flex justify-content-between align-items-center">
                            <div className="card-body-icon">
                                <i className="fas fa-history"></i>
                            </div>
                            <div className="mr-5">{props.logsNumber} logs gravados</div>
                        </div>
                    </div></Link>
                </div>
            </div>
{/*            <div className="row">
                <div className="col">
                    <div className="card text-dark  o-hidden h-100">
                        <div className="card-body bg-light d-flex justify-content-between align-items-center">
                            <div className="card-body-icon">
                                <i className="fas fa-cogs"></i>
                            </div>
                            <div className="mr-5">Gestão</div>
                        </div>
                        <Link to="/configurations">
                            <div className="card-footer bg text-dark clearfix small z-1" href="#">
                                Gerir configurações
                            </div> </Link>
                    </div>
                </div>
            </div>*/}
        </div>
    )
}

export default dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard.js